
import { Period } from 'src/app/assabil-kernel/models/entities/control-tables/period';
import { Product } from 'src/app/assabil-kernel/models/entities/master-data/product-entity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { TargetProductFamily } from './target-product-family';
import { TargetType } from './target-type';

export class RoleTarget extends BaseEntity {

	id                            : number;
	role                          : Role;
	period                        : Period;
  productOrTargetProductFamily  : string ;
	targetType                    : TargetType;
  basedOnProduct                : boolean;
  product                       : Product;
  targetProductFamily           : TargetProductFamily;
  creationDate                  : Date;
  calculationDate               : Date;
  achievementDate               : Date;
	calculatedTarget              : number;

  target                        : number;
  achievement                   : number;
  targetDayAverage              : number;
  achievementDayAverage         : number;
  returnTotal                   : number;
  freeTotal                     : number;
  damagedReturnTotal            : number;
  locked                        : boolean;
  periodDaysNumber              : number;

  trend                         : number;

  constructor() {
    super();

  }
}